var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmergencyDoorIconHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10556_11",
    "data-name": "Group 10556 11",
    transform: "translate(-140 -1010)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6850",
    "data-name": "Rectangle 6850",
    width: 40,
    height: 40,
    rx: 5,
    ry: 5,
    transform: "translate(140 1010)",
    fill: "#24435f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Scanner",
    transform: "translate(150 1018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_31",
    "data-name": "Subtraction 31",
    d: "M2975-4059.007a1.044,1.044,0,0,1-.2-.02l-10-2-.168-.05a1.007,1.007,0,0,1-.635-.931V-4080l.015-.176a1,1,0,0,1,.789-.806l10-2,.177-.02h.02a1,1,0,0,1,.634.228,1,1,0,0,1,.351.6l.015.178v21.993l-.015.177a1.009,1.009,0,0,1-.351.6A1,1,0,0,1,2975-4059.007Zm-4-13a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0,2971-4072Zm12,11h-5v-2h4V-4079h-4v-2h5l.18.016a1,1,0,0,1,.82.984v17.994l-.016.18A1,1,0,0,1,2983-4061.007Z",
    transform: "translate(-2964 4083)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyDoorIconHover);
export default __webpack_public_path__ + "static/media/EmergencyDoorIconHover.e5521edd6d6cefff56a76c3b4aae634c.svg";
export { ForwardRef as ReactComponent };